import React, { Component, Fragment } from 'react';
import axios from 'axios';
import {
    Table,
    Form,
    Icon,
    Button,
    Loader,
    Input, Popup, Segment, Header
} from 'semantic-ui-react';
import { fetchFaculties } from '../../Lookups/util';
import { fetchUserOrganizationalUnit } from '../../Assets/util/roles';
import { toast } from 'react-toastify';
import { FormattedMessage } from 'react-intl';

class NonCycleStudentFaculties extends Component {
    constructor(props) {
        super(props);
        this.state = {
            student: props.student,
            data: [],
            faculties: [],
            loading: true,
            editingRowId: null,
            editedRowData: null,
            saving: false,
            isAdding: false,
            isDeleting: false,
            deletingRowId: null,
            userOrganizationalUnitId: null,
            isMainOU: false,

            organizationalUnitErr: false,
        };
    }

    componentDidMount() {
        this.setState({ loading: true });

        Promise.all([
            fetchFaculties(),
            axios.get(`/non-cycle-student-ou/non-cycle-student/${this.props.student.id}`),
            fetchUserOrganizationalUnit(),
        ])
            .then(([facultiesResponse, studentOrgUnitsResponse, userOrganizationalUnitResponse]) => {
                const faculties = facultiesResponse.data.map(faculty => ({
                    key: faculty.id,
                    value: faculty,
                    text: faculty.name
                }));
                this.setState({
                    faculties,
                    data: studentOrgUnitsResponse.data,
                    loading: false
                });
                if (userOrganizationalUnitResponse) {
                    this.setState({ userOrganizationalUnitId: userOrganizationalUnitResponse.data });
                }
                const isMainOU = studentOrgUnitsResponse.data.some(entry =>
                    entry.mainOrganizationalUnit &&
                    entry.organizationalUnit &&
                    entry.organizationalUnit.id === userOrganizationalUnitResponse.data
                );
                this.setState({ isMainOU });
            })
            .catch(error => {
                this.setState({ loading: false });
            });
    }

    handleDeleteClick = (entry) => {
        this.setState({
            isDeleting: true,
            deletingRowId: entry.id
        });
    };

    handleEditClick = (entry) => {
        this.setState({
            organizationalUnitErr: false,
            editingRowId: entry.id,
            editedRowData: { ...entry }
        });
    };

    handleCancelClick = () => {
        const {
            isAdding,
            editingRowId,
            data
        } = this.state;
        const newData = isAdding
            ? data.filter(d => d.id !== editingRowId)
            : data;

        this.setState({
            data: newData,
            editingRowId: null,
            editedRowData: null,
            isAdding: false,
            isDeleting: false,
            deletingRowId: null,
        });
    };

    handleConfirmClick = () => {
        const {
            editedRowData,
            data,
            isAdding,
            isDeleting,
            deletingRowId
        } = this.state;
        this.setState({ saving: true });

        if (!isDeleting) {
            if (!editedRowData.organizationalUnit) {
                this.setState({ organizationalUnitErr: true });
                toast(<FormattedMessage id="externalStudent.toast.requireFaculty"/>);
                this.setState({ saving: false });
                return;
            }

            const sameOUCount = data.filter(
                d => d.organizationalUnit
                    && d.organizationalUnit.id === editedRowData.organizationalUnit.id
                    && d.id !== editedRowData.id).length;
            if (sameOUCount !== 0) {
                this.setState({ organizationalUnitErr: true });
                toast(<FormattedMessage id="externalStudent.toast.duplicateOrganizationalUnit"/>);
                this.setState({ saving: false });
                return;
            }

            if (editedRowData.mainOrganizationalUnit) {
                const mainOUCount = data.filter(d => d.mainOrganizationalUnit && d.id !== editedRowData.id).length;
                if (mainOUCount > 0) {
                    toast(<FormattedMessage id="externalStudent.toast.singleMainOrganizationalUnit"/>);
                    this.setState({ saving: false });
                    return;
                }
            }
        }

        const payload =
            isDeleting ? {} : {
                organizationalUnitId: editedRowData.organizationalUnit.id,
                nonCycleStudentId: this.props.student.id,
                studentIdentificationNumber: editedRowData.studentIdentificationNumber || '',
                mainOrganizationalUnit: editedRowData.mainOrganizationalUnit || false
            };
        let axiosCall = null;
        if (isDeleting) {
            axiosCall = axios.delete(`/non-cycle-student-ou/${deletingRowId}`);
        } else if (isAdding) {
            axiosCall = axios.post('/non-cycle-student-ou/', payload);
        } else {
            axiosCall = axios.put(`/non-cycle-student-ou/`, {
                ...payload,
                id: editedRowData.id
            });
        }

        axiosCall
            .then(response => {
                axios.get(`/non-cycle-student-ou/non-cycle-student/${this.props.student.id}`)
                    .then(response => {
                        const updatedData = response.data;
                        this.setState({
                            data: updatedData,
                            editingRowId: null,
                            editedRowData: null,
                            saving: false,
                            isAdding: false,
                            isDeleting: false,
                            deletingRowId: null,
                        });

                        if (isAdding) {
                            toast(<FormattedMessage id="externalStudent.toast.facultyAdded"/>);
                        } else if (isDeleting) {
                            toast(<FormattedMessage id="externalStudent.toast.facultyDeleted"/>);
                        } else {
                            toast(<FormattedMessage id="externalStudent.toast.facultyUpdated"/>);
                        }
                    });
            })
            .catch(error => {
                this.setState({ saving: false });

                if (isDeleting) {
                    const msg = error && error.response && error.response.data ? error.response.data : '';
                    if (msg.includes('ConstraintViolationException')) {
                        toast(<FormattedMessage id="externalStudent.toast.facultyDeleteErrorLinked"/>);
                    } else {
                        toast(<FormattedMessage id="externalStudent.toast.facultyDeleteError"/>);
                    }
                } else {
                    toast(<FormattedMessage id="externalStudent.toast.saveError"/>);
                }
            });
    };

    handleInputChange = (field, value) => {
        this.setState(prevState => ({
            editedRowData: {
                ...prevState.editedRowData,
                [field]: value
            }
        }));
    };

    handleAddClick = () => {
        const newRow = {};

        this.setState(prevState => ({
            organizationalUnitErr: false,
            data: [newRow, ...prevState.data],
            editingRowId: newRow.id,
            editedRowData: newRow,
            isAdding: true
        }));
    };

    getFacultyValueById = (id) => {
        const found = this.state.faculties.find(f => f.value.id === id);
        return found ? found.value : null;
    };

    render() {
        const {
            data,
            faculties,
            loading,
            editingRowId,
            editedRowData,
            saving,
            isAdding,
            isDeleting,
            deletingRowId,
            organizationalUnitErr,
            isMainOU,
        } = this.state;

        const localStorageRole = localStorage.getItem('activeRole') || '';
        const isAdmin = localStorageRole === 'Administrator' || localStorageRole === 'AIDA';
        const isStudentService = localStorageRole.slice(0, 10) === 'Studentska';

        if (loading) {
            return <div style={{
                paddingTop: '100px',
                paddingBottom: '100px'
            }}><Loader active inline="centered"/></div>;
        }

        return (
            <Segment.Group>
                <Segment>
                    <Header as="h3">
                        <Header.Content style={{
                            display: 'flex',
                            justifyContent: 'space-between'
                        }}>
                            <FormattedMessage id="externalStudent.faculties"/>
                        </Header.Content>
                    </Header>
                </Segment>
                <Segment compact>
                    <Table basic selectable celled compact textAlign={'left'} verticalAlign={'middle'}>
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell width={1}><FormattedMessage
                                    id="externalStudent.ordinalNumber"/></Table.HeaderCell>
                                <Table.HeaderCell width={4}><FormattedMessage
                                    id="externalStudent.facultyName"/></Table.HeaderCell>
                                <Table.HeaderCell width={3}><FormattedMessage
                                    id="externalStudent.indexNumber"/></Table.HeaderCell>
                                <Table.HeaderCell width={3}><FormattedMessage
                                    id="externalStudent.mainOrganizationalUnit"/></Table.HeaderCell>
                                {
                                    (isStudentService) &&
                                    (<Table.HeaderCell width={2} textAlign="center">
                                        {(isStudentService && isMainOU) &&
                                            (<Popup
                                                content={<FormattedMessage id="externalStudent.add"/>}
                                                position="top center"
                                                trigger={<Button
                                                    basic
                                                    circular
                                                    icon
                                                    size="tiny"
                                                    color="blue"
                                                    onClick={this.handleAddClick}
                                                    disabled={this.state.student.lockedAt || this.state.student.dropoutDate || loading || editingRowId !== null || isAdding || isDeleting /*|| this.state.student.dateTo < this.addDays(new Date(), -15)*/}
                                                >
                                                    <Icon name="plus"/>
                                                </Button>}/>)
                                        }
                                    </Table.HeaderCell>)
                                }
                            </Table.Row>
                        </Table.Header>

                        <Table.Body>
                            {data.map((entry, index) => {
                                const isEditing = entry.id === editingRowId;
                                const current = isEditing ? editedRowData : entry;

                                return (
                                    <Table.Row key={entry.id} verticalAlign={'middle'}
                                               positive={entry.mainOrganizationalUnit}>
                                        <Table.Cell verticalAlign={'middle'}>{index + 1}.</Table.Cell>
                                        <Table.Cell verticalAlign={'middle'}>
                                            {
                                                isEditing && (isAdding && isMainOU) ? (
                                                        <Form.Select
                                                            fluid
                                                            options={faculties}
                                                            value={this.getFacultyValueById(
                                                                current.organizationalUnit && current.organizationalUnit.id
                                                            )}
                                                            placeholder={<FormattedMessage
                                                                id="externalStudent.selectFaculty"/>}
                                                            clearable
                                                            selection
                                                            search
                                                            error={organizationalUnitErr}
                                                            onChange={(e, { value }) => {
                                                                this.handleInputChange('organizationalUnit', value);
                                                            }}
                                                        />
                                                    ) :
                                                    <Fragment>
                                                        {entry.organizationalUnit.name}
                                                    </Fragment>
                                            }
                                        </Table.Cell>
                                        <Table.Cell verticalAlign={'middle'}>
                                            {isEditing && isStudentService ? (
                                                <FormattedMessage id="externalStudent.enterIndexNumber">
                                                    {msg => (
                                                        <Input
                                                            fluid
                                                            placeholder={msg}
                                                            value={current.studentIdentificationNumber || ''}
                                                            onChange={(e) => this.handleInputChange('studentIdentificationNumber', e.target.value)}
                                                        />
                                                    )}
                                                </FormattedMessage>
                                            ) : (
                                                entry.studentIdentificationNumber || ''
                                            )}
                                        </Table.Cell>
                                        <Table.Cell textAlign="center" verticalAlign={'middle'}>
                                            {
                                                isEditing && isAdmin ? (
                                                        <Form.Checkbox
                                                            checked={current.mainOrganizationalUnit || false}
                                                            onChange={(e, { checked }) => this.handleInputChange('mainOrganizationalUnit', checked)}
                                                        />

                                                    ) :
                                                    entry.mainOrganizationalUnit ? (
                                                        <FormattedMessage id="common.yes"/>
                                                    ) : (
                                                        <FormattedMessage id="common.no"/>
                                                    )
                                            }
                                        </Table.Cell>
                                        {isStudentService && (
                                            <Table.Cell textAlign="center" verticalAlign={'middle'}>
                                                {isEditing || (isDeleting && deletingRowId === entry.id) ? (
                                                    <Fragment>
                                                        <Popup
                                                            content={<FormattedMessage id="externalStudent.save"/>}
                                                            position="top center"
                                                            trigger={<Button
                                                                circular
                                                                icon
                                                                size="tiny"
                                                                color="blue"
                                                                onClick={this.handleConfirmClick}
                                                                loading={saving}
                                                                disabled={saving}
                                                            >
                                                                <Icon name="check"/>
                                                            </Button>}/>
                                                        <Popup
                                                            content={<FormattedMessage
                                                                id="externalStudent.cancel"/>}
                                                            position="top center"
                                                            trigger={<Button
                                                                basic
                                                                circular
                                                                icon
                                                                size="tiny"
                                                                color="blue"
                                                                onClick={this.handleCancelClick}
                                                                disabled={saving}
                                                            >
                                                                <Icon name="close"/>
                                                            </Button>}/>
                                                    </Fragment>
                                                ) : (
                                                    <Fragment>
                                                        {(isStudentService && (this.state.userOrganizationalUnitId === current.organizationalUnit.id || isMainOU)) &&
                                                            (<Popup
                                                                content={<FormattedMessage
                                                                    id="externalStudent.edit"/>}
                                                                position="top center"
                                                                trigger={<Button
                                                                    basic
                                                                    circular
                                                                    icon
                                                                    disabled={this.state.student.lockedAt || this.state.student.dropoutDate || isAdding || (isDeleting && deletingRowId !== entry.id) || (editingRowId && editingRowId !== entry.id) /*|| this.state.student.dateTo < this.addDays(new Date(), -15)*/}
                                                                    size="tiny"
                                                                    color="green"
                                                                    onClick={() => this.handleEditClick(entry)}
                                                                >
                                                                    <Icon name="pencil"/>
                                                                </Button>}/>)
                                                        }

                                                        {(isStudentService && (this.state.userOrganizationalUnitId !== current.organizationalUnit.id && isMainOU)) &&
                                                            (<Popup
                                                                content={<FormattedMessage
                                                                    id="externalStudent.delete"/>}
                                                                position="top center"
                                                                trigger={<Button
                                                                    basic
                                                                    circular
                                                                    icon
                                                                    disabled={this.state.student.lockedAt || this.state.student.dropoutDate || isAdding || (isDeleting && deletingRowId !== entry.id) || (editingRowId && editingRowId !== entry.id) /*|| this.state.student.dateTo < this.addDays(new Date(), -15)*/}
                                                                    size="tiny"
                                                                    color="red"
                                                                    onClick={() => this.handleDeleteClick(entry)}
                                                                >
                                                                    <Icon name="trash alternate"/>
                                                                </Button>}/>)}
                                                    </Fragment>
                                                )}
                                            </Table.Cell>)}
                                    </Table.Row>
                                );
                            })}
                            {data.length === 0 && (
                                <Table.Row>
                                    <Table.Cell
                                        textAlign={'left'}
                                        colSpan={!isStudentService ? 4 : 5}>
                                        {<FormattedMessage id="externalStudent.noFaculties"/>}
                                    </Table.Cell>
                                </Table.Row>
                            )}
                        </Table.Body>
                    </Table>
                </Segment>
            </Segment.Group>
        );
    }
}

export default NonCycleStudentFaculties;



// WEBPACK FOOTER //
// ./src/views/NonCycleStudent/NonCycleStudentProfile/NonCycleStudentFaculties.js